import { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';

import PageLoading from '@Components/pageLoading';

function PrivateRoute({ children, userAuth, ...rest }) {
  const [directToPage, setDirectToPage] = useState(<PageLoading maskAll />);

  useEffect(() => {
    if (userAuth === '') {
      setDirectToPage(<Redirect to="/login" />);
    } else {
      setDirectToPage(children);
    }
  }, [userAuth]);

  return <Route {...rest} render={() => directToPage} />;
}

export default PrivateRoute;
